import { h } from 'preact';

import Grid from '@mui/material/Grid';
import ListItemText from '@mui/material/ListItemText';
import Skeleton from '@mui/material/Skeleton';

import styles from '../global.css';

function LazyVariationItem(_props) {
  return (
    <Grid item className={styles.variationHolder} xs={12} md={4}>
      <ListItemText
        primary={<Skeleton width={50} />}
        secondary={<Skeleton width={100} />}
      />
      <Skeleton variant="rounded" width={'100%'} height={250} />
    </Grid>
  );
}

export default function LazyVariations(_props) {
  return (
    <Grid
      container
      className={styles.variationContainer}
      spacing={1}
      justifyContent="center"
    >
      <LazyVariationItem />
      <LazyVariationItem />
      <LazyVariationItem />
      <LazyVariationItem />
      <LazyVariationItem />
    </Grid>
  );
}
